export default "__VITE_ASSET__8b0651e1__"